import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Target = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="184" viewBox="0 0 182 184" width="182" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M91.3 178.45c37.73 0 68.32-2.17 68.32-4.85s-30.59-4.85-68.32-4.85c-37.74 0-68.33 2.17-68.33 4.85s30.6 4.85 68.33 4.85Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M138.17 73.44c-10-27.59-30.35-46.82-50.22-49.83a33 33 0 0 0-16.48 1.51 32 32 0 0 0-4.52 2.05c-20.6 11.33-27.74 44.7-15.77 77.77 11.15 30.8 35.23 51.19 57.13 50.2a33 33 0 0 0 4.97-.6h.01l4.59-1.28.54-.2a33 33 0 0 0 11.8-7.81c14.4-14.66 18.26-43.35 7.96-71.8zm-10.19 46.4c-1.34 5.3-3.5 9.94-6.23 13.42a19.7 19.7 0 0 1-8.75 6.56 18 18 0 0 1-6.22 1.07c-6.98 0-14.89-3.62-22.26-10.2-8.41-7.52-15.48-18.39-19.91-30.61a82 82 0 0 1-4.79-22.28 61 61 0 0 1 1.54-19.25c1.35-5.31 3.5-9.95 6.24-13.43a19.7 19.7 0 0 1 8.74-6.56 18 18 0 0 1 6.23-1.07c6.98 0 14.88 3.62 22.25 10.2a71 71 0 0 1 14.46 18.55v.01a85 85 0 0 1 10.23 34.33q.08 1.16.12 2.28v.02a60 60 0 0 1-1.66 16.95h.01Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m113.28 154.54-9.57 2.68h-.02l-4.4 1.23c-14.31 2.92-30.1-4.03-42.93-17.61a86 86 0 0 1-11.13-14.79c-3.15-5.24-5.9-11-8.14-17.18-6.1-16.83-7.24-33.75-4.17-47.8 2.63-12 8.34-21.92 16.65-27.88A32 32 0 0 1 62 27.77l9.47-2.64a33 33 0 0 0-10.6 6.35c-8.3 7.4-13.52 19.14-15.04 32.9-1.38 12.44.26 26.53 5.34 40.56 11.15 30.81 35.23 51.2 57.13 50.2q2.5-.1 4.97-.6z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M129.65 102.89v-.02l-.12-2.29a82 82 0 0 0-4.79-22.27 85 85 0 0 0-5.45-12.05v-.01a71 71 0 0 0-14.45-18.55c-7.37-6.58-15.28-10.2-22.26-10.2q-3.27 0-6.22 1.06a19.7 19.7 0 0 0-8.74 6.57c-2.74 3.47-4.9 8.11-6.24 13.42a61 61 0 0 0-1.54 19.26 82 82 0 0 0 4.79 22.27c4.42 12.23 11.5 23.1 19.91 30.61 7.37 6.58 15.28 10.2 22.25 10.2q3.27 0 6.23-1.06a19.7 19.7 0 0 0 8.74-6.56c2.73-3.48 4.89-8.12 6.24-13.43a60 60 0 0 0 1.66-16.95zm-22.52 20.7c-9.19 3.32-22.2-9.39-29.09-28.38-6.88-19-5-37.09 4.18-40.41 9.18-3.33 22.2 9.37 29.08 28.37s5.01 37.09-4.17 40.41Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M99.72 103.14c-3.72 1.35-9-3.8-11.8-11.5-2.78-7.71-2.03-15.05 1.7-16.4s9 3.8 11.8 11.5c2.78 7.71 2.03 15.05-1.7 16.4Zm11.58-19.97c-6.88-19-19.9-31.7-29.08-28.37s-11.06 21.42-4.18 40.4c6.88 19 19.9 31.7 29.09 28.38 9.18-3.33 11.05-21.43 4.17-40.42Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M99.72 103.14c-3.72 1.35-9-3.8-11.8-11.5-2.78-7.71-2.03-15.05 1.7-16.4s9 3.8 11.8 11.5c2.78 7.71 2.03 15.05-1.7 16.4Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m56.36 140.84-3.34 15.79-11.39 4.66 3.6-35.23a86 86 0 0 0 11.13 14.78Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m53.03 156.63-3.97 18.72H40.2l1.44-14.06z" fill={shades.black} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="m77.3 150.53 13.62 27.38h14.37l-9.33-21.47z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m131.63 147.55-10.56 9.9-2.65-4.4a33 33 0 0 0 11.8-7.8z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M145.78 170.57h-16.8l-7.91-13.12 10.56-9.9z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M87.95 23.61a33 33 0 0 0-16.48 1.51L62 27.77q-.67.14-1.33.3c6.82-5.97 15.7-9.52 25.88-9.77z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M86.55 18.3c-10.18.25-19.06 3.8-25.88 9.77a32 32 0 0 0-5.04 1.69l-5.55-17.32 6.63 2.87 5.51 2.38 3.48-5.65 2.72-4.43 4.63 2.82 5.7 3.47 2.37-4.88 1.93-3.99z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m81.13 9.02-2.37 4.88-5.7-3.46 3.2-4.28z" fill={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m65.7 12.04-3.48 5.65-5.5-2.38c1.01-1.85 2.93-5.63 2.93-5.63z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M65.77 40.9s5.77 6.2 1.9 11.62c-3.88 5.43-11.46 3.44-11.46 3.44s1.47 6.98-5.77 8.36c-1.58.3-3.13.27-4.61.06a23 23 0 0 1-9.51-4.02s-1.32.31-3.4.72c2.63-12.01 8.34-21.92 16.65-27.89.83.66 1.3 1.08 1.3 1.08s2.32-4.32 10-2.79q2 .39 4.48 1.37c8.69 3.48.41 8.06.41 8.06v-.02z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M150.74 132.38s-12.92-1.63-18.09 2.84c-5.16 4.48 9.47 5.67 9.47 5.67s-8.78 2.09-4.13 5.35c4.65 3.28 17.91 1.03 17.91 1.03s-.09 6.89 4.82 4.87 5.6-7.19 5.6-7.19 10.68.34 10.68-6.2-14.72-3.7-14.72-3.7-.17-5.43-5.94-5.85c-5.78-.44-5.6 3.18-5.6 3.18Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M15.9 46.97S1.26 50.6 5.91 55.58c4.65 5 27.56-.43 27.56-.43s6.88 5.34 14.12 3.96 5.77-8.35 5.77-8.35 7.58 1.98 11.46-3.45c3.87-5.42-1.9-11.62-1.9-11.62s8.28-4.58-.42-8.06c-11.28-4.51-14.47 1.43-14.47 1.43s-10.5-9.53-22.13-9.13-6.29 13.18-6.29 13.18-10.33-.95-13.17 5.16 9.47 8.7 9.47 8.7z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
